import axios from 'axios'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'
import config from '@/assets/js/config.js'

export default class AdministartorService {
  constructor (passwordCrypter) {
    this.passwordCrypter = passwordCrypter
    this.apis = {
      getMe: () => axios.get(APIConfig.BPIURL + '/me'),
      updateMe: (payload) => axios.put(APIConfig.BPIURL + '/me', payload),
      updatePassword: (payload) => axios.put(APIConfig.BPIURL + '/me/password', payload)
    }
    // fake data
    if (config.useFakeData) {
      this.apis = {
        getMe: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: {
                Profile: {
                  Name: 'Debug Admin Name'
                }
              }
            }
          }
          resolve(res)
        })
      }
    }
  }

  getMe (vm) {
    vm.isLoading = true
    return this.apis.getMe()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateMe (vm, payload) {
    vm.isLoading = true
    return this.apis.updateMe(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          vm.$set(vm.$store.state.admin.Profile, 'Name', payload.Profile.Name)
        }
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updatePassword (vm, form) {
    vm.isLoading = true
    let payload = {
      Old: this.passwordCrypter.cryptPassword(form.Old),
      New: this.passwordCrypter.cryptPassword(form.New)
    }
    return this.apis.updatePassword(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
